package org.multipaz.verification

/**
 * Abstract base class for W3C Digital Credentials API responses.
 */
sealed class DcResponse
